import { z } from "zod";

export const launchDarklyInfoSchema = z.object({
	customerId: z.string(),
	siteId: z.string(),
});
